<template>
  <div class="border-b--medium">
    <!-- Key: {{ v_key }} -->

    <template v-if="v_type === 'boolean'">
      <v-checkbox v-model="localValue" :label="v_name" hide-details></v-checkbox>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    v_value: null,
    v_key: null,
    v_name: null,
    v_type: null
  },
  data () {
    return {
      types: ['boolean', 'object', 'array']
    }
  },
  computed: {
    localValue: {
      get () {
        return this.v_value
      },
      set (nv) {
        this.$emit('update:v_value', nv)
      }
    }
  }
}
</script>